import axios from 'axios'
const { VUE_APP_API_URL, VUE_APP_TEST_ERROR, VUE_APP_VT_API_URL } =
  process.env

const loginBookingNumber = async (username, bookingNumber, source) => {
  try {
    // will normally be ext, only internal consultants will change it to int
    let sourceParam = 'EXT'
    if (source) sourceParam = source.toUpperCase()
    let system = 'UK'
    if (bookingNumber.charAt(0).toUpperCase() === 'R') {
      system = 'IE'
    }
    const res = await axios.post(`${VUE_APP_VT_API_URL}/vt-api/superfacts/check`, {
      bookingName: username,
      bookingNumber: bookingNumber,
      source: sourceParam,
      system: system
    })
    if (res && res.data) {
      return res.data
    }
  } catch (err) {
    return null
  }
}

const loginCorporate = async (clientref, email, token) => {
  try {
    // will normally be ext, only internal consultants will change it to int
    const sourceParam = 'INT'
    const system = 'UK'
    const apiURL = VUE_APP_API_URL
    const res = await axios.post(
      `${apiURL}/api/superfacts/check-corp`,
      {
        bookingClientRef: clientref,
        bookingEmail: email,
        source: sourceParam,
        system: system
      },
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    )
    if (res && res.data) {
      return res.data
    }
  } catch (err) {
    return null
  }
}

const loginToken = async (username, password, corporate) => {
  try {
    if (!corporate) {
      corporate = false
    }
    const res = await axios.post(`${VUE_APP_API_URL}/api/user/login`, {
      username,
      password,
      corporate
    })
    if (res && res.data) {
      return res.data
    }
  } catch (err) {
    return null
  }
}

const sendCode = async (bookingNumber, destination) => {
  try {
    const res = await axios.post(`${VUE_APP_API_URL}/api/user/send-code`, {
      bookingNumber,
      destination
    })
    if (res && res.data) {
      return res.data
    }
  } catch (err) {
    return null
  }
}

const confirmCode = async (code, confirmId) => {
  try {
    const res = await axios.post(`${VUE_APP_API_URL}/api/user/confirm-code`, { code, confirmId })
    if (res && res.data) {
      return res.data
    }
  } catch (err) {
    return null
  }
}

const getLoginOptions = async (bookingNumber) => {
  try {
    const rnd = Math.random()
    const res = await axios.get(`${VUE_APP_API_URL}/api/user/login-options?rnd=${rnd}`, {
      params: {
        bookingNumber
      }
    })
    if (res && res.data) {
      return res.data
    }
  } catch (err) {
    return null
  }
}

const decodeFriendFamily = async (unid) => {
  const result = { error: false }

  try {
    const url = VUE_APP_TEST_ERROR || `${VUE_APP_API_URL}/api/decode-link/${unid}`

    const res = await axios.get(url)
    if (res && res.data) {
      result.data = res.data
      return result
    }
  } catch (err) {
    result.error = true
    return result
  }
}

const resetPassword = async (email) => {
  try {
    const res = await axios.post(`${VUE_APP_API_URL}/api/user/forgotten`, { username: email })
    if (res && res.data) {
      return res.data
    }
  } catch (err) {
    return null
  }
}

const decodeWeddingAbroad = async (unid) => {
  const result = { error: false }

  try {
    const url = VUE_APP_TEST_ERROR || `${VUE_APP_API_URL}/api/decode-link/${unid}`

    const res = await axios.get(url)
    if (res && res.data) {
      result.data = res.data
      return result
    }
  } catch (err) {
    result.error = true
    return result
  }
}

export {
  loginBookingNumber,
  loginToken,
  loginCorporate,
  resetPassword,
  decodeFriendFamily,
  decodeWeddingAbroad,
  getLoginOptions,
  sendCode,
  confirmCode
}
